import React from "react";
import ReactDOM from "react-dom/client";

import "./firebase";
import "./index.css";
import AppRouter from "./routers";

const root = ReactDOM.createRoot(document.getElementById("root"));

window.fdVariables = {
    algolia: {
        appId: "FVVSXZ6C3V",
        apiKey: "c7384284fa5c5afb875ea209c17e6442",
    },
    mapsApiKey: 'AIzaSyAbXe-KuyvLhGgpCWNWEAPWPjMImZtd94k',
    apiBaseurl: document.location.hostname.includes('localhost') ? "http://127.0.0.1:5001/plateforme-matchmaking-fd/us-central1/api" : "https://us-central1-plateforme-matchmaking-fd.cloudfunctions.net/api",
    adminUrl: document.location.hostname.includes('localhost') ? "http://localhost:3000/" : "https://admin.matchmaking-francedigitale.org",
    frontUrl: document.location.hostname.includes('localhost') ? "http://localhost:3000/" : "https://matchmaking-francedigitale.org",
}

root.render(
    <AppRouter />
);
